import * as angular from 'angular';
import {IController, IWindowService} from "angular";
import {BringozToastService} from "../../services/bringoz-toast.service";

export class TextCopyButtonCtrl implements IController {

  text: any;
  showText: boolean;

  public showCopyBtn:boolean;

  constructor(private $window: IWindowService, private bringozToastService: BringozToastService) {
  }

  copyToClipboard() {
    this.$window.navigator.clipboard.writeText(this.text).then((succ)=>{
      const message = {
        body: 'TEXT_COPIED_TO_CLIPBOARD'
      };
      this.bringozToastService.success(message);
    });
  }


}

angular
  .module('bringoz.admin.commons')
  .component('textCopyButton', {
    bindings: {
      text: '<',
      showText: '<?',
    },
    template: require('./text-copy-button.html').default,
    controller: TextCopyButtonCtrl
  });


